export default __webpack_public_path__ + "static/hero_partnerzy-fb2acf8f2cd2f3104da111ab42713d1d.webp";